export default __webpack_public_path__ + "src/assets/images/required/user-1WLE.png";